module.exports = __webpack_public_path__ + "static/vtt1-3ef38d92163474c6d1a83d3ee43398d8.jpg";